import script from "./copytext.vue?vue&type=script&setup=true&name=copy_text&lang=js"
export * from "./copytext.vue?vue&type=script&setup=true&name=copy_text&lang=js"

import "./copytext.vue?vue&type=style&index=0&id=09fc1a7f&scoped=true&lang=css"

import exportComponent from "E:\\SYH-SPMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09fc1a7f"]])

export default __exports__